/* eslint-disable*/
import axios from 'axios';

const state = {
    api_status: 400,
    api_data:'',
    tweet_data: {
        tweet_id:'',
        called_url: ''
    },
    recent_tweets:[]
}

const getters = {
    getApiStatus: (state)=>{
        return state.api_status
    },
    getApiData: (state)=>{
        return state.api_data
    },
    getTweetData: (state)=>{
        return state.tweet_data
    },
    getRecentTweets:(state)=>{
        return state.recent_tweets;
    }
}

const actions = {
    saveApiData:({ commit, dispatch }, data) =>{
        commit('setSaveApiData', data)
    },
    getApiTweets:({ commit }, data) =>{
        let parsed = [];
        const formdata = new FormData();
        formdata.append('screen_name', data);
        axios.post("https://slow-band-v1.herokuapp.com/api/timeline", formdata).then(res =>{
            res.data.tweets.forEach((element, index) => {
               parsed[index] = JSON.parse(element);
            });
            return parsed;
        }).then(parsed => {
            commit('setApiTweets', parsed);
        });

    }
}

const mutations = {
    setSaveApiData:(state, data)=>{
        state.api_data = data.data.data;
        state.api_status = data.data.status;
        state.tweet_data.called_url = data.called_url;
        state.tweet_data.tweet_id = data.tweet_id;
    },
    setApiTweets:(state, data)=>{
        state.recent_tweets = data
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}